import { render, staticRenderFns } from "./DerivedCurveForm.vue?vue&type=template&id=63f172a8"
import script from "./DerivedCurveForm.vue?vue&type=script&lang=js"
export * from "./DerivedCurveForm.vue?vue&type=script&lang=js"
import style0 from "./DerivedCurveForm.vue?vue&type=style&index=0&id=63f172a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports